/**
 * Debug utilities for authentication conflicts
 * 
 * Use these functions in the browser console to debug auth issues
 */

import { tabCoordinator } from "./tabCoordinator";
import { authConflictDetector } from "./authConflictDetector";

// Make debugging functions available globally
declare global {
  interface Window {
    debugAuth: {
      getTabInfo: () => any;
      getConflictHistory: () => any;
      clearConflicts: () => void;
      checkAuthSafety: () => boolean;
      logTabCoordination: () => void;
    };
  }
}

// Initialize debug utilities
window.debugAuth = {
  getTabInfo: () => {
    const activeTabs = tabCoordinator.getActiveTabsInfo();
    const currentTabId = tabCoordinator.getCurrentTabId();
    const shouldHandleAuth = tabCoordinator.shouldHandleAuth();
    const isInJoinFlow = tabCoordinator.isInJoinFlowContext();

    return {
      currentTab: {
        id: currentTabId,
        shouldHandleAuth,
        isInJoinFlow,
        path: window.location.pathname
      },
      activeTabs,
      totalTabs: activeTabs.length,
      summary: `${activeTabs.length} active tabs, current tab ${shouldHandleAuth ? 'CAN' : 'CANNOT'} handle auth`
    };
  },

  getConflictHistory: () => {
    return authConflictDetector.getConflictHistory();
  },

  clearConflicts: () => {
    authConflictDetector.clearConflictHistory();
    console.log('[DebugAuth] Conflict history cleared');
  },

  checkAuthSafety: () => {
    return authConflictDetector.isAuthContextSafe();
  },

  logTabCoordination: () => {
    const info = window.debugAuth.getTabInfo();
    console.table(info.activeTabs);
    console.log('Current tab info:', info.currentTab);
    console.log('Summary:', info.summary);
  }
};

console.log('[DebugAuth] Debug utilities loaded. Use window.debugAuth.* to debug auth conflicts.');
console.log('Available methods:', Object.keys(window.debugAuth));

export {}; // Make this a module